export const services = [{
        title: "Technology Enthusiast",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Software Engineer",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Photographer",
        icon: 'https://csgeeek.github.io/web.png',
    },
];

export const name = 'Surjeet';

export const experiences = [{
        'company': 'WorinWell',
        'role': 'Web Development Back-end',
        'duration': 'Aug 2023 - Sep 2023',
        'logo': 'https://lh5.googleusercontent.com/proxy/ievmKihd137m1-4y74mdAtNqu90xSHcwEgBfSbTT6wVs_yNTXi_PnZ-bbdldqzvLLqn6emhuFnwMTjgBemMtKcH7K8NwEaoXf_Fm2A7nQ1Lejk04_rxdkkH4',
        'points': [
            'Developed 2 Projects During Internship: Laravel Task Manager App using REST API and POSTMAN, Laravel BMS.',
            'Designed Database Schema: Ensured efficient data storage and retrieval, reducing data query times by 30%.',
            'Developed RESTful APIs: Enabled data interaction, leading to a 25% increase in system performance and a 40% reduction in data retrieval errors.',
            'Simplified Development Tasks: Created multiple shared components, improving efficiency and teamwork among developers 📈.',
            'Enhanced Backend Performance: Made significant contributions to backend development, optimizing essential components for improved efficiency.',
            'Implemented Data Security: Provided role-based access control, ensuring secure data access and enhancing overall product security ⚙️.'
        ],
        'url': 'https://www.1stop.ai/',
    },
    {
        'company': 'AT & T',
        'role': 'Technical Intern',
        'duration': 'Jan 2023 - March 2023',
        'logo': 'https://www.att.com/ecms/dam/att/consumer/global/logos/att_globe_500x500.jpg',
        'points': [
            'Gained experience with Git version control contributing to the development and maintenance of code repositories.',
            'Worked on the application dashboard, making it more user-friendly and improving its overall functionality📱.'
        ],
        'url': 'https://www.att.com/',
    },
]



export const EMAIL_JS_SERVICE_ID = 'service_90wb9t5';
export const EMAIL_JS_TEMPLATE_ID = 'template_8l87rew';
export const EMAIL_JS_PUBLIC_KEY = 'pHPjc9RGGkF66r86N';